let HorizontalBar = require('../components/charts/horizontal-bar');
let Page          = require('../mixins/base-page');
let Pie           = require('../components/charts/pie');
let Subscriptions = require('mixins/subscriptions');

module.exports = {
  	mixins: [Page, Subscriptions],

  	components: {
  		HorizontalBar,
		Pie
	},

  	data() {
		return {
			dialogs: {
				achievements: false,
				fundamentals: false,
				progress: false
			},
			progressDialogShowing: false,
			queueOrFavorites: 'queue',
			showFavorites: false,
			showQueue: false,
			welcomeMessageShowing: true
		}
  	},

  	methods: {
  		showProgressDialog(dialogName) {
			Object.keys(this.dialogs).forEach(key => {
			    this.dialogs[key] = false;
			});

  			this.dialogs[dialogName] = true;
  			this.progressDialogShowing = true;
  		},

  		queueLoaded(items) {
  			if(items.length > 0) {
  				this.showQueue = true;
  			}
  		},

  		favoritesLoaded(items) {
  			if(items.length > 0) {
  				this.showFavorites = true;
  			}
  		}
  	}
};
